import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import { Form, Formik } from "formik";
import api from "../../../../API";
import { useSelector } from "react-redux";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { useNavigate } from "react-router-dom";

interface IFileTypes {
  id: number;
  object: File;
}

interface UploadResult {
  fileName: string;
  state: string;
}


// const SampleRejectRsnDialog = () => {
const SttSrtReUploadDialog = (props: any) => {

  const nav = useNavigate();

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [files, setFiles] = useState<IFileTypes[]>([]);
  const [uploadResult , setUploadResult] = useState<UploadResult[]>([]);

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const fileUpload = async () => {

    if (files.length === 0) {
      alert("업로드할 파일을 선택해주세요.");
      return;
    }
    const formData = new FormData();
    // 선택한 파일들을 formData에 추가
    // const file_data:any = {};

    formData.append("email", email);


    let srt_cnt = 0;

    let srt_list = Array<any>([])

    


    files.forEach((file:any) => {
      console.log('업로드할 파일' , file.object)
      const filename_split = file.object.name.split(".")
      const extension = filename_split.pop();
      const file_name = filename_split.join(".");
      console.log('file_name', file_name)
      console.log('extension', extension)

      
      
      if(extension && ["srt"].includes(extension.toLowerCase())){
        formData.append("srt", file.object.name);
        srt_list.push(file_name)
        srt_cnt +=1;
      }
      else{
        alert(file.object.name + ' 확장자('+extension+')를 확인하여주세요.')
        return;
      }
      formData.append("files", file.object);

      // formData.append("files_lastmodified", {
      //   fileName : file.object.name,
      //   lastModifiedDate : file.object.lastModifiedDate.toISOString(),
      // });

    });

    console.log('srt_list',srt_list)

    // return;

    setBackdrop(true)
    // nvSttSrtOnlyUpload
    // dialogOrgUpload
    const result = await api.post("/nvSttSrtReUpload", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
        // "Content-Type": "application/json"
      }
    })
    .then((res:any) => {
      setBackdrop(false); 
      console.log("file upload ", res); 
      setUploadResult(res.data.datas); 
      // setFiles([]);
      alert('업로드 처리가 끝났습니다. 결과를 꼭 확인하여 주세요.')
      // props.myScriptList();
      // props.setUploadDialogOpen(false);
    })
    // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {
      setBackdrop(false); 
      var res = JSON.parse(error.response.data);
      console.error('에러',res); 
      alert('파일 업로드에 실패하였습니다.\n'+ res['fileName'] + '\n'+ res['state'])
      // alert(res['fileName'] + ' 파일은 이미 업로드 되어있습니다. [상태 : ' + res['state'] + ']')
    })
    // alert("파일 업로드 실패. " + error.response.data.error);
      
  };

  const onChangeFiles = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any): void => {
      let selectFiles: File[] = [];
      let tempFiles: IFileTypes[] = files;
  
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }
  
      for (const file of selectFiles) {
        const extension = file.name.split(".").pop();
  
        // 파일업로드 확장자 통과목록

        // if (extension === "mp3" || extension === "wav" || extension === "ogg" || extension === "m4a" || extension === "M4A") {

        const isDuplicate = tempFiles.some(
          (tempFile) =>
            tempFile.object.name === file.name
        );
        if (isDuplicate) {
          alert(`${file.name} 파일은 이미 추가되었습니다.`);
        } else if (
          extension &&
          ["mp3","mp4","wav","ogg","m4a","aac","srt"].includes(extension.toLowerCase())
        ) {
        tempFiles = [
          ...tempFiles,
          {
            id: fileId.current++,
            object: file,
          },
        ];
        } else {
          // alert("오디오 파일만 업로드 가능합니다.");
          alert("업로드가 불가한 파일 확장자를 포함합니다. 다시확인하여 주세요.");
        }
      }
      setFiles(tempFiles);
    },
    [files]
  );
  
  const handleFilterFile = useCallback(
    (id: number): void => {
      setFiles(files.filter((file: IFileTypes) => file.id !== id));
    },
    [files]
  );

  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer!.files && e.dataTransfer!.files.length > 0) {
      const extension = e.dataTransfer!.files[0].name.split(".").pop();
      if (extension && ["mp3","wav","ogg","m4a","srt","txt","png","jpg","jpeg"].includes(extension.toLowerCase())
      ) {
        setIsDragging(true);
      } else {
        setIsDragging(false);
      }
    }
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      onChangeFiles(e);
      setIsDragging(false);
    },
    [onChangeFiles]
  );

  const initDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  

  useEffect(() => {
    initDragEvents();

    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);


  return (
    <Box >
    <Dialog maxWidth="md" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>SRT 수집데이터 재업로드</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdrop} >
            <CircularProgress color="inherit" /> 업로드 중...
          </Backdrop>
          <Box sx={{width:"100%"}}>
            <Box>
              <Paper sx={{width: "770px", padding: "38px", borderTop: "4px solid #3e36a5"}}>
                <Box sx={{padding:"20px 8px 8px 8px"}}>
                  <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "32px", letterSpacing:"-2px"}}>SRT 재업로드</Box>
                  <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
                  <div className="DragDrop">
                  <input
                    type="file"
                    id="fileUpload"
                    style={{ display: "none" }}
                    multiple={true}
                    onChange={onChangeFiles}
                  />

                  <label
                    className={isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}
                    htmlFor="fileUpload"
                    ref={dragRef}
                    style={{width: "100%" , backgroundColor:"#71a7e5"}}
                  >
                    <Box sx={{fontWeight:700, fontSize:"32px", color:"#fff"}}>파일 첨부</Box>
                  </label>
                  
                  <div className="DragDrop-Files">
                    {files.length > 0 ?
                      files.map((file: IFileTypes) => {
                        const {
                          id,
                          object: { name },
                        } = file;

                        return (
                          <Box key={id} sx={{width:(uploadResult.length > 0 ? "100% !important":"300px") ,display:"flex",justifyContent: "flex-start !important"}}>
                            <Box sx={{display:"flex", alignItems: "center"}}>
                              <Box sx={{width:"180px",marginRight:"40px"}}>{name}</Box>
                              <Box
                                className="DragDrop-Files-Filter"
                                onClick={() => handleFilterFile(id)}
                              >
                                <CancelIcon fontSize="small" />
                              </Box>
                            </Box>
                            <Box>
                              {uploadResult.length > 0 ? 
                                uploadResult.filter((value:any) => value.fileName === name).map((result:any) =>
                                  <Box sx={{padding:2}} key={result.fileName}>
                                    {/* <Box sx={{fontWeight:600}}>{result.fileName}</Box> */}
                                    {result.state == "성공" ? 
                                      <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                                      : 
                                      <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                                  </Box>
                                )
                              :""}
                            </Box>
                          </Box>
                        );
                      }) : ""}
                  </div>
                    {/* {(uploadResult.length > 0) ? 
                      (<Box sx={{border :"2px solid red", fontSize:"12px", padding:"8px"}}>
                        <Box sx={{fontSize:"16px", fontWeight:600}}>파일 업로드 결과</Box>
                        {uploadResult.map((result:UploadResult) => 
                          <Box sx={{padding:2}} key={result.fileName}>
                            <Box sx={{fontWeight:600}}>{result.fileName}</Box>
                            {result.state == "성공" ? 
                              <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                              : 
                              <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                          </Box>
                        )}
                      </Box>)
                    : ""} */}
                  <Box sx={{display:"flex" , justifyContent: "end"}}>
                    <Button sx={{width: "230px", fontWeight: 500, backgroundColor: "#3bbd30", color: "#fff"}} variant="contained" onClick={fileUpload}>파일 업로드</Button>
                  </Box>
                </div>
                </Box>
                <Box sx={{fontWeight:500, marginLeft:2, fontSize:"14px"}}>
                  <Box color="blue" sx={{marginBottom:"4px"}}>대화 - 수집 메뉴에서 음성만 올라온 건에 대해 SRT를 {<b style={{color:"red"}}>재업로드</b>} 하기 기능입니다.</Box>
                </Box>
              </Paper>
              
            </Box>
          </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            nav("/admin/hrm/dialogOrg");
          }}
        >
          취소
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default SttSrtReUploadDialog;
